import { Input } from "antd";
const { Search } = Input;
const UiSearch = ({
    onChange,
    handleSearch,
    ...restProps
}) => {
    return <div>
        <Search
            onChange={onChange}
            onSearch={handleSearch}
            {...restProps}
        />
    </div>
};
export default UiSearch